// extracted by mini-css-extract-plugin
export default {"dateInput":"DateInput-module__dateInput___JQbx8","error":"DateInput-module__error___R1Kt7","textAlignRight":"DateInput-module__textAlignRight___M9UY7"};